import { MenuApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const roomMenusetApi = {
  index: wrap(MenuApi, MenuApi.prototype.indexMenuSetList),
};
